<template>
   <div v-if="fournisseur">
     <div class="entete border-entete">
       <div class="level">
         <div class="level-left">
           <div class="columns is-gapless">
             <div class="column">
               <h1 class="title is-size-3">
                 {{ fournisseurAlreadyExist ? $t('editionFournisseur.titleEdition',
                 { nomCommercial: nomCommercial }) : $t('editionFournisseur.titleCreation')}}
               </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
             </div>
           </div>
         </div>
         <div class="level-right">
           <div class="buttons">
              <button class="button" @click="$router.go(-1)">
                {{ $t('editionFournisseur.actions.cancel')}}
              </button>
              <button class="button is-addOrEdit" @click="saveFournisseur">
                {{ $t('general.button.sauvegarder') }}
              </button>
              <piece-jointe-button
                class="mgr-2"
                :perm="getPerm.maj">
              </piece-jointe-button>
           </div>
         </div>
       </div>
     </div>
     <error-msg-component :messages="messages" class="mgt-20px" :error="error"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          :title="'general.problemOccurred'" :withEmplyFields="true"
                          @close="error = $event"/>

     <div class="columns mgt-20px">
       <div class="column is-narrow"><logo/></div>
       <div class="column">
         <div class="card">
           <header class="header-card">
             <p>{{ $t('editionFournisseur.informationGenerale.title')}}</p>
           </header>
           <div class="card-content">
             <div class="columns is-multiline">
               <div class="column is-3">
                 <b-field :label="$t('editionFournisseur.informationGenerale.codeAfficheur')">
                   <b-input disabled></b-input>
                 </b-field>
               </div>
               <div class="column is-3">
                 <input-tier-nom-commercial
                      :label="$t('editionFournisseur.informationGenerale.nomJuridique')"
                      v-model="fournisseur.nomCommercial"
                      :tierId="fournisseur.id"
                      :query="fournisseurQuery"
                      :path="getNameRouteDetail">
                  </input-tier-nom-commercial>
               </div>
               <div class="column is-3">
                 <b-field :label="$t('editionFournisseur.informationGenerale.siret')">
                   <b-input v-model="fournisseur.siret"></b-input>
                 </b-field>
               </div>
               <div class="column is-3">
                 <b-field :label="$t('editionFournisseur.informationGenerale.apeNaf')">
                   <b-input v-model="fournisseur.ape"></b-input>
                 </b-field>
               </div>
               <div class="column is-3">
                 <b-field
                   :label="$t('editionFournisseur.informationGenerale.tvaIntracommunautaire')">
                   <b-input v-model="fournisseur.tvaIntracommunautaire"></b-input>
                 </b-field>
               </div>
               <div class="column is-3">
                 <b-field
                   :label="$t('editionFournisseur.informationGenerale.role')">
                    <qd-taginput type="is-primary" expanded v-model="fournisseur.sousTypes"
                               :allow-new="false" :open-on-focus="true" autocomplete
                               field="libellei18n"
                               :data="getDataFilter"
                               @typing="getFilteredSousTypeWritting"
                               @input="getTypeTags">
                      <template #default=" { option }">
                        {{ getLibelle(option) }}
                      </template>
                      <template #tag="{ tag }">
                        {{ getLibelle(tag) }}
                      </template>
                    </qd-taginput>
                 </b-field>
               </div>
               <div class="column is-3">
                <b-field :label="$t('editionFournisseur.informationGenerale.applicationTva')">
                  <b-select v-model="fournisseur.applicationTva" expanded>
                    <option
                      v-for="item in constantes.LISTE_APPLICATION_TVA"
                      :value="item.code"
                      :key="item.code">
                      {{ $t(item.libelle) }}
                    </option>
                  </b-select>
                </b-field>
               </div>
               <div class="column is-3" v-if="isFactor">
                 <b-field
                   :label="$t('editionFournisseur.informationGenerale.numeroCedant')">
                   <b-input v-model="fournisseur.numeroCedant"></b-input>
                 </b-field>
               </div>
               <div class="column is-3" v-if="isFactor">
                 <b-field
                   :label="$t('editionFournisseur.informationGenerale.numeroFichier')">
                   <qd-numberinput v-model="fournisseur.numeroFichier" :controls="false">
                   </qd-numberinput>
                 </b-field>
               </div>
               <div class="column is-narrow">
                <b-field class="has-text-default bfieldWhitoutLabel">
                  <b-checkbox v-model="fournisseur.interne">
                    {{ $t('addEditFournisseurs.informationsGenerales.interne')}}
                  </b-checkbox>
                </b-field>
              </div>
             </div>
           </div>
         </div>
       </div>
     </div>
     <div class="columns">
       <div class="column" :class="hideInfoCmd ? 'is-12 pdh-0' : 'is-6'">
         <div class="card">
           <header class="header-card">
             <p>
               {{ $t('editionFournisseur.infoComptable.title')}}
             </p>
           </header>
           <div class="card-content">
             <div class="columns is-multiline">
               <div class="column"
                 :class="isFactor ? 'is-4' : 'is-3'">
                 <b-field :label="$t('editionFournisseur.infoComptable.compteComptable')">
                   <b-input v-model="fournisseur.compteComptable"></b-input>
                 </b-field>
               </div>
               <div class="column is-4" v-if="!(isFactor || isDemarcheur)">
                 <b-field :label="$t('editionFournisseur.infoComptable.referenceUniqueMandat')">
                   <b-input v-model="fournisseur.referenceUniqueMandat"></b-input>
                 </b-field>
               </div>
               <div class="column is-5" v-if="!(isFactor || isDemarcheur)">
                 <b-field :label="$t('editionFournisseur.infoComptable.dateSignatureMandatSepa')">
                   <b-datepicker show-week-number
                                nearby-selectable-month-days
                                v-model="fournisseur.dateSignatureMandatSepa"
                                icon="calendar-today"
                                :editable="true">
                    </b-datepicker>
                 </b-field>
               </div>
             </div>
           </div>
         </div>
       </div>
       <div class="column is-6" v-if="!hideInfoCmd">
         <info-commande :tiers="fournisseur"></info-commande>
       </div>
     </div>
     <div class="card mgt-20px">
       <header class="header-card" >
         <p>{{ $t('editionFournisseur.adresse.title')}}</p>
       </header>
       <div class="card-content">
         <div class="columns">
           <div class="column is-6">
             <b-field :label="$t('editionClient.informations.postalAddress')">
               <adresse
                 :adresse="fournisseur.adressePostale"
                 adresseName='adressePostale'
                 :tableName="TIERS"/>
             </b-field>
           </div>
           <div class="column is-6">
            <span>
            <b-checkbox v-model="fournisseur.adresseFacturationDifferente"
                        @input="selectionAdresseFacturationclient()">
              {{ $t('editionClient.informations.addressBillingDifferent')}}
            </b-checkbox>
            <adresse :adresse="fournisseur.adresseFacturation"
                         adresseName='adresseFacturation' :tableName="TIERS"
                      class="mgt-5px"
                         v-if="fournisseur.adresseFacturationDifferente"/>
            </span>
           </div>
         </div>
       </div>
     </div>

     <div class="columns mgt-20px">
       <div class="column"  :class="isDemarcheur ? 'is-12 pdh-0' : 'is-6'">
         <div class="card">
           <header class="header-card">
             <p>{{ $t('editionFournisseur.coordonee.title')}}</p>
           </header>
           <div class="card-content">
             <div class="columns is-multiline">
               <div class="column is-6">
                 <b-field :label="$t('editionFournisseur.coordonee.telephone')">
                   <b-input v-model="fournisseur.telephone"></b-input>
                 </b-field>
               </div>
               <div class="column is-6">
                 <b-field :label="$t('editionFournisseur.coordonee.telephonePortable')">
                   <b-input v-model="fournisseur.portable"></b-input>
                 </b-field>
               </div>
               <div class="column is-6">
                 <input-email :label="$t('editionFournisseur.coordonee.email')"
                                  v-model="fournisseur.email"/>
               </div>
               <div class="column is-6">
                 <input-url  :label="$t('editionFournisseur.coordonee.siteInternet')"
                                 v-model="fournisseur.siteWeb"/>
               </div>
             </div>
           </div>
         </div>
       </div>
       <div class="column is-6" v-if="!isDemarcheur">
         <div class="card">
           <header class="header-card">
             <p>
               {{ $t('editionFournisseur.banque.title')}}
             </p>
           </header>
           <div class="card-content">
             <div class="columns is-multiline">
               <div class="column is-6">
                 <b-field :label="$t('editionFournisseur.banque.rib')">
                   <b-input v-model="fournisseur.rib.banque"></b-input>
                 </b-field>
               </div>
               <div class="column is-6">
                 <b-field :label="$t('editionFournisseur.banque.titulaire')">
                   <b-input v-model="fournisseur.rib.titulaire"></b-input>
                 </b-field>
               </div>
               <div class="column is-9">
                  <input-iban :label="$t('editionFournisseur.banque.iban')"
                            v-model="fournisseur.rib.iban"/>
               </div>
               <div class="column is-3">
                 <b-field :label="$t('editionFournisseur.banque.bic')">
                   <b-input v-model="fournisseur.rib.bic"></b-input>
                 </b-field>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>

     <div class="card">
       <header class="header-card">
         <p>
           {{ $t('editionFournisseur.contact.title')}}
         </p>
       </header>
       <div class="card-content">
         <contacts
           :contacts="fournisseur.contacts"
           :client="fournisseur"/>
       </div>
     </div>

     <div class="card mgt-20px">
       <header class="header-card">
         <p>
           {{ $t('editionFournisseur.commentaire.title')}}
         </p>
       </header>
       <div class="card-content">
         <div class="columns bottom">
           <div class="column is-12">
             <b-field :label="$t('editionFournisseur.commentaire.commentaire')">
                <textarea class="textarea"
                          rows="6"
                          v-model="fournisseur.commentairesInternes"></textarea>
             </b-field>
           </div>
         </div>
       </div>
     </div>

     <div v-if="isFactor" class="card mgt-20px">
       <header class="header-card">
         <p>
           {{ $t('editionFournisseur.commentaire.commentairesFactor')}}
         </p>
       </header>
       <div class="card-content">
         <div class="columns bottom">
           <div class="column is-12">
             <b-field :label="$t('editionFournisseur.commentaire.commentaire')">
               <qd-text-editor v-model="fournisseur.commentaireFactor" />
             </b-field>
           </div>
         </div>
       </div>
     </div>

     <div class="card mgt-20px">
       <header class="header-card">
         <p>{{ $t('piecesJointes.attachments')}}</p>
       </header>
       <div class="card-content">
         <pieces-jointes :checkPermissions="true"/>
       </div>
     </div>

   </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererClient from '@/services/tiers/genererTiers';
import messageErreur from '@/services/general/messageErreur';
import AppBreadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Logo from '@/components/general/Logo';
import Adresse from '@/components/general/adresse';
import adresseGenerer from '@/services/general/genererAdresse';
import inputEmail from '@/components/general/inputEmail';
import inputUrl from '@/components/general/inputUrl';
import InputIban from '@/components/general/inputIban';
import contacts from '@/components/clients/clients/editionClient/contacts';
import piecesJointes from '@/components/general/piecesJointes';
import messageSucces from '@/services/general/messageSucces';
import { insertTiers, updateTiers } from '@/services/tiers/saveTiers';
import { get } from '@/api/tiers';
import { getAllByTiers } from '@/api/contacts';
import {
  LISTE_SOUS_TYPE,
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_AFFICHEUR,
  TIERS_SOUS_TYPE_CONFRERE,
  TIERS_SOUS_TYPE_TECHNICIEN,
  TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL,
  TIERS_SOUS_TYPE_FACTOR,
  TIERS_SOUS_TYPE_DEMARCHEUR,
  TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
  LISTE_APPLICATION_TVA,
} from '@/configuration/tiers/tiersConf';
import traductionLibelleEtat from '@/services/devisCommandes/traductionLibelleEtat';
import infoCommande from '@/components/commun/tiers/editionTiers/infoCommande';
import { TIERS } from '@/configuration/ville/villeConf';
import validationGeneral from '@/services/validation/validation';
import champsFournisseurTranslator from '@/services/tiers/champsFournisseurTranslator';
import initialize from '@/services/tiers/initializeTiers';
import InputTierNomCommercial from '@/components/general/input/tierNomCommercialInput/tierNomCommercialInput';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { CONFRERE, FOURNISSEUR_MATERIEL } from '@/configuration/gabed/permissionsGabedConf';
import { LIEU_DE_LIVRAISON } from '@/configuration/achat/permissionsConf';
import { AFFICHEUR, TECHNICIEN } from '@/configuration/logistique/permissionsLogistiqueConf';
import { FACTOR } from '@/configuration/permissionsBodacConf';
import { DEMARCHEUR } from '@/configuration/baux/permissionsBauxConf';
import validation from '@/services/commun/fournisseur/validationFournisseur';

const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      TIERS: TIERS,
      filteredTags: traductionLibelleEtat(this.$i18n, LISTE_SOUS_TYPE),
      fournisseur: null,
      error: false,
      messages: [],
      nomCommercial: '',
      champsVide: [],
      messagesChampsVide: [],
      constantes: {
        LISTE_APPLICATION_TVA,
      },
    };
  },
  components: {
    AppBreadcrumb,
    errorMsgComponent,
    Logo,
    Adresse,
    inputEmail,
    inputUrl,
    contacts,
    piecesJointes,
    infoCommande,
    InputIban,
    InputTierNomCommercial,
    pieceJointeButton,
  },
  computed: {
    sousTypeParam() {
      return this.$route.params.sousTypeFrom;
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('editionFournisseur.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('editionFournisseur.breadcrumb.liste', { sousTypePluriel: this.getSousTypePluriel }), route: { name: this.getNameRouteListe }, isActive: false },
        { title: this.fournisseurAlreadyExist ? this.$i18n.t('editionFournisseur.breadcrumb.titleEdition') : this.$i18n.t('editionFournisseur.breadcrumb.titleCreation'), route: '', isActive: true },
      ];
    },
    getSousTypePluriel() {
      switch (this.sousTypeParam) {
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return this.$i18n.t('fournisseur.sousTypesPluriel.afficheur');
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return this.$i18n.t('fournisseur.sousTypesPluriel.lieuDeLivraison');
        case TIERS_SOUS_TYPE_TECHNICIEN:
          return this.$i18n.t('fournisseur.sousTypesPluriel.technicien');
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return this.$i18n.t('fournisseur.sousTypesPluriel.fournisseurMateriel');
        case TIERS_SOUS_TYPE_FACTOR:
          return this.$i18n.t('fournisseur.sousTypesPluriel.factor');
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return this.$i18n.t('fournisseur.sousTypesPluriel.demarcheur');
        case TIERS_SOUS_TYPE_CONFRERE:
          return this.$i18n.t('fournisseur.sousTypesPluriel.confrere');
        default:
          return '';
      }
    },
    getNameRouteListe() {
      switch (this.sousTypeParam) {
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return 'l.logistique.afficheur';
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return 'l.achat.lieu_de_livraison';
        case TIERS_SOUS_TYPE_TECHNICIEN:
          return 'l.logistique.technicien';
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return 'l.gabed.fournisseur_materiel';
        case TIERS_SOUS_TYPE_FACTOR:
          return 'l.bodac.factor';
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return 'l.baux.demarcheur';
        case TIERS_SOUS_TYPE_CONFRERE:
          return 'l.gabed.confrere';
        default:
          return 'home';
      }
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    fournisseurAlreadyExist() {
      return this.fournisseur.id !== undefined;
    },
    hideInfoCmd() {
      return this.isLieuDeLivraison || this.isDemarcheur;
    },
    fournisseurQuery() {
      return {
        nomsCommercialOuNomsJuridique: [this.fournisseur.nomCommercial],
        societeId: this.societeActiveId,
        type: TIERS_TYPE_FOURNISSEUR,
        sousType: [this.sousTypeParam],
      };
    },
    getDataFilter() {
      return this.filteredTags
        .filter((type) => !this.fournisseur.sousTypes.includes(type.code))
        .map((type) => type.code);
    },
    getNameRouteDetail() {
      const route = LISTE_SOUS_TYPE.find((type) => type.code === this.sousTypeParam);
      return route.routeConsultation || 'home';
    },
    isFactor() {
      return this.isType(TIERS_SOUS_TYPE_FACTOR);
    },
    isDemarcheur() {
      return this.isType(TIERS_SOUS_TYPE_DEMARCHEUR);
    },
    isLieuDeLivraison() {
      return this.isType(TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON);
    },
    getPerm() {
      switch (this.sousTypeParam) {
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return LIEU_DE_LIVRAISON;
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return AFFICHEUR;
        case TIERS_SOUS_TYPE_TECHNICIEN:
          return TECHNICIEN;
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return FOURNISSEUR_MATERIEL;
        case TIERS_SOUS_TYPE_FACTOR:
          return FACTOR;
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return DEMARCHEUR;
        case TIERS_SOUS_TYPE_CONFRERE:
          return CONFRERE;
        default:
          return 'home';
      }
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    getSousTypeFournisseurWithTraduction(fournisseur) {
      const sousTypeWithLibelle = [];
      fournisseur.sousTypes.forEach((type) => {
        const typeFind = this.filteredTags.find((typeWithTrad) => {
          return typeWithTrad.code === type;
        });
        if (typeFind !== undefined) {
          sousTypeWithLibelle.push(typeFind);
        }
      });
      return sousTypeWithLibelle;
    },
    selectionAdresseFacturationclient() {
      if (!this.fournisseur.adresseFacturationDifferente) {
        this.fournisseur.adresseFacturation = adresseGenerer();
      }
    },
    getTypeTags() {
      this.filteredTags = LISTE_SOUS_TYPE.filter((option) => {
        return !this.fournisseur.sousTypes.map(c => c.code).includes(option.code);
      });
    },
    getFilteredSousTypeWritting(text) {
      this.filteredTags = LISTE_SOUS_TYPE
        .filter((type) => {
          return this.fournisseur.sousTypes.some((sousType) => {
            return sousType !== type.code;
          });
        })
        .filter((option) => {
          return option.libellei18n.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
        });
    },
    async saveFournisseur() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesChampsVide = [];
        this.champsVide = [];
        this.error = false;
        this.messages = [];
        let fournisseur = cloneDeep(this.fournisseur);
        if (!this.fournisseurAlreadyExist) {
          fournisseur.contacts.forEach((el) => {
            delete el.guid;
          });
          fournisseur.societeId = this.societeActiveId;
          fournisseur = await insertTiers(fournisseur);
          await this.insertAttachments(fournisseur.id);
          messageSucces(this.$i18n.t('editionFournisseur.notifications.successCreation'));
        } else {
          fournisseur = await updateTiers(fournisseur);
          await this.updateAttachments(fournisseur.id);
          messageSucces(this.$i18n.t('editionFournisseur.notifications.successChange'));
        }
        loadingComponent.close();
        await this.$router.push({
          name: this.getNameRouteDetail,
          params: { id: fournisseur.id, sousTypeFrom: this.sousTypeParam },
        });
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, champsFournisseurTranslator);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    updateSousTypeForCreation(fournisseur) {
      fournisseur.sousTypes = [this.sousTypeParam];
    },
    isType(type) {
      return this.fournisseur.sousTypes.some((el) => el === type);
    },
    getLibelle(code) {
      return LISTE_SOUS_TYPE.find((type) => type.code === code)?.libellei18n || '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Client' });
      if (!this.$route.params.id) {
        const fournisseur = genererClient();
        fournisseur.type = TIERS_TYPE_FOURNISSEUR;
        this.updateSousTypeForCreation(fournisseur);
        this.fournisseur = fournisseur;
        this.setInformationPage(this.$t('pageMultiModule.fournisseur.creation'));
      } else {
        const fournisseur = (await get(this.$route.params.id)).data.result;
        fournisseur.contacts = (await getAllByTiers(fournisseur.id)).data.result.items;
        this.nomCommercial = cloneDeep(fournisseur.nomCommercial);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: fournisseur.nomCommercial }));
        await this.setAttachmentElementId({ id: fournisseur.id });
        initialize(fournisseur);
        this.fournisseur = fournisseur;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
